import { sessionState } from 'src/app/core/services/signal-state.storage';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { mygarage } from 'src/app/shared/Models/Constants';
import { StatusDTO } from 'src/app/shared/Models/Models';

@Component({
    selector: 'app-gdo-step-completion-status-webview',
    templateUrl: './gdo-step-completion-status-webview.component.html',
    styleUrls: ['./gdo-step-completion-status-webview.component.scss'],
    standalone: false
})
export class GdoStepCompletionStatusWebviewComponent implements OnInit {
  myGarageHost = 'https://mygarage.honda.com';
  isAcura: boolean = false;
  isWebView:boolean=true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: StatusDTO,
    public matDialogRef: MatDialogRef<GdoStepCompletionStatusWebviewComponent>,
    private _appService: AppService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.myGarageHost = mygarage;
    
    this.isWebView =  this._appService.getWebviewCurrentStatus();
    // this.switchTheme();
  }

  onClickClose() {
    
    this.matDialogRef.close();
    if (this.data.redirectToUR) {
      this.router.navigate(['/']);
      sessionState.clear();
      window.location.href =
        this.myGarageHost + '/s/my-account?tab=subscription';
    }
  }
  onClickBackToMyGarage() {
    this.matDialogRef.close();
    this.router.navigate(['/']);
    sessionState.clear();
    window.location.href = this.myGarageHost + '/s/my-account?tab=subscription';
  }
}
